import { useTranslation } from 'react-i18next';
import { ILocked } from 'ui/component/Icons.tsx';
import { Tooltip } from 'ui/component/Tooltip.tsx';

type Props = {
  id?: string;
};

export const DocumentForbidden = ({ id }: Props) => {
  const { t } = useTranslation();

  return (
    <Tooltip text={t('messages.documentAccessDenied')} data-id={id}>
      <div className="relative border border-grey-border px-3 py-2 transition-all">
        <ILocked className="ml-auto fill-grey-label" size={24} />
      </div>
    </Tooltip>
  );
};
